import { ChangeDetectorRef, Component, ViewChild } from '@angular/core';
import { HeaderComponent } from '../../components/header/header.component';
import { FooterComponent } from '../../components/footer/footer.component';
import {
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  FormBuilder,
  Validators,
} from '@angular/forms';
import { DatasearchService } from '../../_services/datasearch.service';
import { NgIf } from '@angular/common';
import { CommonModule } from '@angular/common';
import { getCountries, getCountryCallingCode } from 'libphonenumber-js'; // @ts-ignore
import { RecaptchaModule, ReCaptchaV2Component } from 'ng-recaptcha';
import { MessageService } from 'primeng/api';
import { ToastModule } from 'primeng/toast';
import { SidebarComponent } from "../sidebar/sidebar.component";
import { GlobalService } from '../../_services/global.service';

@Component({
  selector: 'app-support',
  standalone: true,
  imports: [
    FormsModule,
    ReactiveFormsModule,
    NgIf,
    CommonModule,
    RecaptchaModule,
    ToastModule,
    HeaderComponent,
    FooterComponent,
    SidebarComponent
],
  templateUrl: './support.component.html',
  styleUrl: './support.component.scss',
  providers: [MessageService],
})
export class SupportComponent {
  @ViewChild('recaptchaRef') recaptchaRef!: ReCaptchaV2Component; // Access the reCAPTCHA element
  contactUsForm!: FormGroup;
  formSubmitted = false;
  errorMessage: any;
  alertVisible = false;
  head: any[] = [];
  recaptchaResponse: string | null = null;
  recaptchaSiteKey = '6LcgKAotAAAAAKjyj-l04VHEm7Qc-IEP0xQK1tw1'; // live
  // recaptchaSiteKey = '6Lcpo3QqAAAAAIKDJyb4lg4QKCWMuQMA7VxbP9uD'; // local
  countries: any[] = [];
  originalCountries: any[] = [];
  currentPage: string = 'contact';
  mapLink: string = 'https://maps.app.goo.gl/FQf6fJJt42hpY7KM8';
  mapLink1:string = 'https://maps.app.goo.gl/zN6xURYsdRkMqFPP8';
  heading = '';
  toggle_sidebar = false;
  constructor(
    private fb: FormBuilder,
    private datasearch: DatasearchService,
    private messageService: MessageService,
    private cdref: ChangeDetectorRef,
    private globalService: GlobalService
  ) {}

  ngOnInit() {
    // Automatically use the local key when running on localhost to prevent the "domain not supported" error
    if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
      this.recaptchaSiteKey = '6Lcpo3QqAAAAAIKDJyb4lg4QKCWMuQMA7VxbP9uD'; // local
    }

    this.loadCountryCodes();
    this.conatctForm();
    this.getHeading();
    this.globalService.sendMenuIndex(2);
  }

  loadCountryCodes() {
    const uniqueCountries = new Map();
    getCountries().forEach((country) => {
      const code = `+${getCountryCallingCode(country)}`;
      const flag = `https://flagcdn.com/16x12/${country.toLowerCase()}.png`;
      if (!uniqueCountries.has(code)) {
        uniqueCountries.set(code, { code, flag });
      }
    });
    this.countries = Array.from(uniqueCountries.values());
  }

  conatctForm() {
    this.contactUsForm = this.fb.group({
      name: ['', [Validators.required]],
      number: ['', [Validators.required, Validators.pattern(/^[0-9]{10}$/)]],
      email: ['', [Validators.required, Validators.email]],
      subject: ['', [Validators.required]],
      message: ['', [Validators.required]],
      country_code: ['+91', [Validators.required]],
      query_type: ['contact'],
    });
  }

  // Handle the reCAPTCHA response
  onCaptchaSuccess(token: string | null) {
    this.recaptchaResponse = token;
  }

  // Reset reCAPTCHA
  resetCaptcha() {
    this.recaptchaResponse = null; // Reset the response manually
    this.recaptchaRef.reset(); // Reset the reCAPTCHA widget
  }

  submit_contactus_form() {
    this.formSubmitted = true;
    // Check form validity and recaptcha
    if (this.contactUsForm.valid && this.recaptchaResponse) {
      const formDataWithoutRecaptcha = { ...this.contactUsForm.value };

      const postdata = {
        data: {
          ...formDataWithoutRecaptcha,
          date: new Date().toLocaleString(),
        },
      };

      this.datasearch.sendInquiryForm(postdata).subscribe(
        (response) => {
          // console.log('Form submitted successfully', response);
          this.errorMessage = '';
          this.alertVisible = true;
          this.contactUsForm.reset();
          this.formSubmitted = false;
          this.contactUsForm.reset({ country_code: '+91' });
          this.resetCaptcha(); // Reset reCAPTCHA after successful form submission
          setTimeout(() => {
            this.alertVisible = false;
          }, 10000);
        },
        (error) => {
          console.error('Error submitting form', error);
          this.errorMessage =
            'An error occurred while submitting the form. Please try again later.';
        }
      );
    } else {
      this.errorMessage =
        'Please fill out all required fields correctly and complete the reCAPTCHA.';
    }
  }

  getHeading() {
    this.datasearch.getAllHeadings().subscribe((res) => {
      if (res.success) {
        this.head = res.data.filter(
          (heading: any) => heading.page === this.currentPage
        );
      }
    });
  }

  closeAlert() {
    this.alertVisible = false;
  }
  copyMapLink(): void {
    navigator.clipboard
      .writeText(this.mapLink)
      .then(() => {
        this.messageService.add({
          severity: 'success',
          summary: 'Copied!',
          detail: 'Map link copied to clipboard',
          life: 3000,
        });
      })
      .catch((err) => {
        console.error('Failed to copy the link: ', err);
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Failed to copy the link',
          life: 3000,
        });
      });
  }

  ngAfterViewInit() {
    this.cdref.detectChanges();
  }

  receiveHeading(event: string){
    this.heading = event;
    this.cdref.detectChanges();
  }

  receiveSidebarEvent(event: boolean){
    this.toggle_sidebar = event;
    this.cdref.detectChanges();
  }

  copyMapLink1(): void {
    navigator.clipboard
      .writeText(this.mapLink1)
      .then(() => {
        this.messageService.add({
          severity: 'success',
          summary: 'Copied!',
          detail: 'Map link copied to clipboard',
          life: 3000,
        });
      })
      .catch((err) => {
        console.error('Failed to copy the link: ', err);
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Failed to copy the link',
          life: 3000,
        });
      });
  }
}
